import { useEffect,useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Image } from "react-bootstrap";

//Destructuring is like a magic trick that lets you pick out just the toy you want from the box without touching the others. 
//You can do this by giving the toy a special name and pulling it out directly. It makes it easier to get exactly what you need from the box.
//It has special pieces of information called parameters that help the website know what you're looking for. useParams is like a magical tool that lets you read those special pieces of information from the URL.

//In summary, destructuring is a way to pick out specific things easily, like toys from a box, and useParams is a special tool that helps you read important information from the website's address, just like finding treasures on a treasure map.

export default function Grid1() { 
    const {sign} = useParams();
    const [zodiac, setZodiac] = useState(); //lets you pick out each sign and assign its specifc zodiac info

    useEffect(()=>{ //changes our component when it first loads
        fetch("https://us-central1-zodiacwebbe.cloudfunctions.net/api/data") //asking for our data from our api
            .then(resp=>resp.json()) //turns all my data into json (readable) data
            .then(allsigns=>{ //from our new readable data - we only take the data we need 
                setZodiac(allsigns.find(el=>el.sign === sign)) //  we are saying that we want to find something specific in the data. 
                //We are looking for an object that has a property called sign that is the same as the sign we have in our component. When we find it, we will store it in a special place called zodiac using the setZodiac function.

            })
    },[sign]) //whenever sign changes the useeffect is triggered 
// changes my moodboard based on each sign i clicked
    console.log("=====>", zodiac);
  if(!zodiac) return <h2> loading </h2> //if its not a zodiac it says loading 
  //: this code helps us check if we have the information we need in our zodiac. If we don't have it yet, we show a message that says "loading" and remind ourselves to be patient while the computer fetches the information for us.

  const imgUri = process.env.PUBLIC_URL+"/images/"; //makes my imgs show

    return (
        <>
        <h2>{sign.toUpperCase()}</h2>
        <Container className="grid">  
        <Row>
        <Col>
                <Image src={imgUri+zodiac["img-1"]} /> 
                
            
                </Col>
            </Row>

            <Row>
                <Col >{zodiac["affirm-1-text"]}</Col>
            </Row>
        </Container>

        </>
    );
} // connects my img to my zodiac info - connects my affirm to my zodiac info 
// (showing my img and the my affirm under) 